import getValue from "utils/value-types/get-value/credentials";
import { get } from "lodash";

const CREDENTIAL_FIELD = "daf6ae65-a010-4ae2-848a-e2dd247ddd0d";

export default ({ values }) =>
  get(getValue(values[CREDENTIAL_FIELD]), ["records", 0, "id"]);
